import Skeleton from '../skeleton/Skeleton';
import { StyledCampaignDetail } from './CampaignDetail.styles';

/** The whole page's shape, shown until the campaign, its stats, its week and its activity have all arrived. */
const CampaignDetailSkeleton = () => (
  <StyledCampaignDetail $tint="var(--hd-muted)" $ring="var(--hd-border)" $dot="var(--hd-border)" aria-busy="true">
    <main className="detail-main">
      <Skeleton width={110} height={16} radius="6px" />

      <section className="surface-card hero-card">
        <div className="hero-row">
          <div className="hero-identity">
            <Skeleton width={80} height={80} radius="22px" resp />
            <div>
              <Skeleton width={220} height={26} radius="8px" resp />
              <Skeleton width={160} height={14} radius="6px" margin="10px 0 0" resp />
              <Skeleton width={320} height={14} radius="6px" margin="8px 0 0" resp />
            </div>
          </div>
          <div className="hero-actions">
            <Skeleton width={120} height={40} radius="18px" />
            <Skeleton width={100} height={40} radius="18px" />
          </div>
        </div>
      </section>

      <section className="kpi-grid">
        {[0, 1, 2, 3].map(key => (
          <div key={key} className="surface-card kpi-card">
            <Skeleton width={100} height={12} radius="6px" resp />
            <Skeleton width={70} height={28} radius="8px" margin="12px 0 0" resp />
          </div>
        ))}
      </section>

      <section className="surface-card panel health-card">
        <div className="health-head">
          <div className="panel-identity">
            <Skeleton width={36} height={36} radius="12px" />
            <div>
              <Skeleton width={170} height={16} radius="6px" />
              <Skeleton width={260} height={12} radius="6px" margin="6px 0 0" resp />
            </div>
          </div>
          <Skeleton width={120} height={24} radius="999px" />
        </div>
        <div className="health-grid">
          <div className="health-score">
            <Skeleton width={112} height={112} circle />
            <div className="health-bars">
              {[0, 1, 2, 3].map(key => (
                <div key={key}>
                  <Skeleton width="100%" height={12} radius="6px" />
                  <Skeleton width="100%" height={6} radius="999px" margin="6px 0 0" />
                </div>
              ))}
            </div>
          </div>
          {[0, 1].map(box => (
            <div key={box} className="health-box">
              <Skeleton width={180} height={14} radius="6px" />
              {[0, 1, 2].map(key => (
                <Skeleton key={key} width="100%" height={64} radius="12px" margin="12px 0 0" />
              ))}
            </div>
          ))}
        </div>
      </section>

      <section className="charts-grid">
        <div className="surface-card panel chart-wide">
          <Skeleton width={170} height={18} radius="6px" />
          <Skeleton width={220} height={13} radius="6px" margin="8px 0 0" />
          <Skeleton width="100%" height={288} radius="14px" margin="16px 0 0" />
        </div>
        <div className="surface-card panel activity-panel">
          <Skeleton width={140} height={18} radius="6px" margin="0 0 16px" />
          {[0, 1, 2, 3, 4].map(key => (
            <div key={key} style={{ display: 'flex', gap: 12, marginTop: key ? 14 : 0 }}>
              <Skeleton width={8} height={8} circle />
              <div style={{ flex: 1 }}>
                <Skeleton width="70%" height={13} radius="6px" />
                <Skeleton width="30%" height={11} radius="6px" margin="6px 0 0" />
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="surface-card panel estimate-card">
        <Skeleton width={170} height={16} radius="6px" />
        <Skeleton width={240} height={12} radius="6px" margin="6px 0 0" resp />
        <div className="estimate-grid">
          {[0, 1].map(key => (
            <div key={key}>
              <Skeleton width="100%" height={14} radius="6px" />
              <Skeleton width="100%" height={8} radius="999px" margin="10px 0 0" />
              <Skeleton width="100%" height={8} radius="999px" margin="6px 0 0" />
            </div>
          ))}
        </div>
      </section>
    </main>
  </StyledCampaignDetail>
);

export default CampaignDetailSkeleton;
